module.exports = __webpack_public_path__ + "img/educationalTraining4.166f1ffc.png";